import { useContext, useState } from "react";

import Button from "antd/lib/button";
import MailOutlined  from "@ant-design/icons/MailOutlined";
import { ModalContext } from "../../../../../contexts/modal/index.context";
import Popconfirm from "antd/lib/popconfirm";
import { PopconfirmProps } from "./types";
import ReloadOutlined  from "@ant-design/icons/ReloadOutlined";
import { SessionContext } from "../../../../../contexts/session/index.context";
import { TableContext } from "../../../../../contexts/table/index.context";
import { TranslationContext } from "../../../../../contexts/translation/index.context";
import message from "antd/lib/message";
import { request } from "../../../../../services";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";

//UI



//Icons



export function ReloadElectronicMail(props: PopconfirmProps) {
  const { intl } = useContext(TranslationContext);
  const context = useContext(ModalContext);

  const handleOk = async () => {
    context.setRefresh(true);
  };

  return (
      <Button
        className={styles["button"]}
        disabled={props.disabled}
        onClick={handleOk}
        icon={<ReloadOutlined />}
        title={intl("update")}
        />
  );
}

export function GetElectronicMail(props: PopconfirmProps) {
  const [loading, setLoading] = useState(false);
  const { disabled, setDisabled, setRefresh } = useContext(ModalContext);
  const { intl } = useContext(TranslationContext);
  const { setSessionData } = useContext(SessionContext);
  const { contextTableData, setContextTableData } = useContext(TableContext);
  const url = "/directories/incoming-email";
  const usingEmailData = JSON.parse(
      sessionStorage.getItem("electronic_mail_data") || "null"
    )?.selectedEmail;

  const info = (success: boolean | undefined, error: string | undefined) => {
    success? message.success(intl("incoming-mail-received"))
      : message.error(error?.includes("found")? intl("incoming-mail-files-no-found") : intl("incoming-mail-files-not-download"));
  };
  const handleOk = async () => {
    const ids: number[] = [];
    const hasMissingFiles = contextTableData?.some((item: any) => !item?.files?.length);
    if (hasMissingFiles) {
      info(false, "no found");
      return;
    } else {
      contextTableData?.forEach((item: any) => {
        ids.push(item.id);
      });
    }

    setLoading(true);
    const success = (
      await request(
        `${url}/getmaildata`,
        {
          method: "post",
          body: {
            id: ids,
            email: usingEmailData,
            page: url?.split("/").pop(),
            url,
            documentsId:props.documentsId
        },
          cancelTokenKey: "getmaildata",
        }
      )
    );
    info(success?.success, success?.error);
    setLoading(false);
    setRefresh(true);
    setDisabled({ ...disabled, edit: true });
    setSessionData({});
  };

  return (
    <Popconfirm
      title={intl("incoming-mail-retrieve-from-mailbox")}
      onConfirm={handleOk}
      okButtonProps={{ loading, className: styles["popconfirm"] }}
      okText={intl("ok")}
      cancelText={intl("cancel")}
    >
      <Button
        className={styles["button"]}
        disabled={contextTableData?.length < 1}
        icon={<MailOutlined />}
        title={intl("get")}
      >
      </Button>
    </Popconfirm>
  );
}